module.exports = __webpack_public_path__ + "static/media/DSC_0763.9a9ea89b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scenery/DSC_0763.jpg
// module id = 700
// module chunks = 0